import React from 'react'

interface Props {
  width?: string
  height?: string
  fill?: string
}

const IconActivity = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 24 24">
      <path stroke={fill} strokeWidth="2" d="M3 12h4l2 7 4-14 2 7h6"/>
    </svg>
  )
}

export default IconActivity